export const DATE_CONFIG = {
  WEEK: {
    FIRST_DAY: 7,
    WEEKEND_DAYS: [6, 7],
    MINIMAL_DAYS: 1,
  },
  LOCALE: "en-US",
  FORMATS: {
    DISPLAY_DATE: "M/d/yyyy",
    DISPLAY_TIME: "h:mm a",
    DISPLAY_DATETIME: "M/d/yyyy h:mm a",
    ISO_DATE: "yyyy-MM-dd",
  },
} as const;

export type DateConfig = typeof DATE_CONFIG;
